import { createSlice, createSelector } from "@reduxjs/toolkit";

const employeeLeaveSlice = createSlice({
	name: "employeeLeave",
	initialState: {
		loading: false,
		selectedTab: "Employee",
	},
	reducers: {
		setEmployee: (state, action) => {
			state.employee = action.payload;
		},
		setLeave: (state, action) => {
			state.leave = action.payload;
		},
		setSelectedTab: (state, action) => {
			state.selectedTab = action.payload;
		},
	},
});

// Extract the action creators object and the reducer
export const { actions, reducer } = employeeLeaveSlice;

export const selectors = {
	getEmployee: createSelector(
		(state) => state.employeeLeave,
		(employee) => employee
	),
	getLeave: createSelector(
		(state) => state.employeeLeave,
		(leave) => leave
	),
	getSelectedTab: createSelector(
		(state) => state.employeeLeave,
		(selectedTab) => selectedTab
	),
};

export const setEmployee = (values) => async (dispatch, getState) => {
	dispatch(actions.setEmployee(values));
};
export const setLeave = (values) => async (dispatch, getState) => {
	dispatch(actions.setLeave(values));
};
export const setSelectedTab = (values) => async (dispatch, getState) => {
	dispatch(actions.setSelectedTab(values));
};

export default reducer;
